import React from 'react'

// Componentes
import InputFecha from '../../components/shared/InputFecha.jsx'
import Select from '../../components/shared/Select.jsx'
import InputObservaciones from '../../components/shared/InputObservaciones.jsx'
import api from "../../apiClient/v1";

// Styles
import * as css from './TablaAuditoriaSemanal.css'
import classNames from 'classnames/bind'
import ObservacionCliente from './ObservacionCliente.jsx';
let cx = classNames.bind(css)

class RowAuditoriaSemanal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            facturable: this.props.auditoria.aud_facturable
        };
    }
    focusElemento(elemento) {
        if (elemento === 'dia') {
            this.inputFecha.focus()
        } else {
            console.error(`focusElemento(): Elemento "${elemento}" no encontrado`)
        }
    }
    onChangeFacturable(e) {
        let data = {}
        data.facturable = e.target.value == 0 ? 1 : 0
        api.auditoria.actualizar(this.props.auditoria.aud_idAuditoria, data)
            .then((response) => {
                this.setState({
                    facturable: data.facturable
                })
                    .catch((error) => {
                        console.log(error)
                    })
            })
    }
    guardarAuditoria() {
        let cambiosAuditoria = {}
        console.log('guardando auditoria')
        if (this.props.puedeModificar) {
            // la FECHA es valida, y ha cambiado?
            let estadoInputFecha = this.inputFecha.getEstado()
            if (estadoInputFecha.valid && estadoInputFecha.dirty) {
                cambiosAuditoria.fechaProgramada = estadoInputFecha.fecha
            } else if (estadoInputFecha.valid === false) {
                return console.log(`fecha ${estadoInputFecha.fecha} invalida`)
            }

            // el AUDITOR ha cambiado?
            let estadoSelectAuditor = this.selectAuditor.getEstado()
            if (estadoSelectAuditor.dirty)
                cambiosAuditoria.idAuditor = estadoSelectAuditor.seleccionUsuario

            let estadoSelectSuspendida = this.selectSuspendida.getEstado()
            if (estadoSelectSuspendida.dirty)
                cambiosAuditoria.idEstadoSuspendido = estadoSelectSuspendida.seleccionUsuario

            let estadoInputObservacion = this.inputObservacion.getEstado()
            if (estadoInputObservacion.dirty)
                cambiosAuditoria.observacion = estadoInputObservacion.valor

            let estadoInputObservacionCliente = this.inputObservacionCliente ? this.inputObservacionCliente.getEstado() : null
            if (estadoInputObservacionCliente && estadoInputObservacionCliente.dirty)
                cambiosAuditoria.observacion_cliente = estadoInputObservacionCliente.valor

            let perecible = this.props.auditoria.aud_perecible
            cambiosAuditoria.perecible = perecible
        }
        // almenos uno de los ementos debe estar "dirty" para guardar los cambios
        if (JSON.stringify(cambiosAuditoria) !== "{}") {
            this.props.guardarAuditoria(this.props.auditoria.aud_idAuditoria, cambiosAuditoria)
        } else {
            console.log('auditoria sin cambios, no se actualiza')
        }
    }

    eliminarAuditoria() {
        if (!this.props.puedeModificar)
            return alert('no tiene permisos para realizar esta acción')
        this.props.eliminarAuditoria(this.props.auditoria)
    }

    render() {
        let auditor = this.props.auditoria.aud_auditor
            ? [{ valor: this.props.auditoria.aud_idAuditor, texto: this.props.auditoria.aud_auditor }]
            : []
        const Auditores = this.props.auditores.map(usuario => {
            return { valor: usuario.id, texto: `${usuario.nombre1} ${usuario.apellidoPaterno}` }
        })
        const opcionesAuditores = auditor.concat(Auditores);
        return (
            <tr className={`${this.props.mostrarSeparador ? css.trSeparador : ''} `} style={{
                backgroundColor: this.props.auditoria.aud_sensores ? 'rgb(224 242 254)' : this.props.auditoria.aud_smuBodega ? 'rgb(224 231 255)' : this.props.auditoria.aud_perecible ? 'rgb(220 183 245)' : 'white',
            }}>
                {/* Correlativo */}
                <td className={css.tdCorrelativo2}>
                    <p title={this.props.auditoria.aud_idAuditoria}>{this.props.index + 1}</p>
                </td>
                {/* Facturable */}
                <td className={css.tdCorrelativo}>
                    {this.props.auditoria.aud_sensores == 0 && this.props.auditoria.aud_smuBodega == 0 && !this.props.auditoria.aud_perecible && this.props.puedeVerExcelFacturacion ?
                        <div style={{ display: 'flex', gap: '2px' }}>
                            <input type='checkbox' value={this.state.facturable} checked={this.state.facturable == 1 ? true : false} onChange={this.onChangeFacturable.bind(this)} />
                            <ObservacionCliente
                                refer={ref => this.inputObservacionCliente = ref}
                                idAuditoria={this.props.auditoria.aud_idAuditoria}
                                observacion={this.props.auditoria.aud_observacion_cliente}
                                onGuardar={this.guardarAuditoria.bind(this)}
                                puedeModificar={this.props.puedeModificar}
                            />
                        </div>
                        : null}
                </td>
                {/* Fecha */}
                <td className={css.tdFecha}>
                    <InputFecha
                        puedeModificar={this.props.puedeModificar} //this.props.auditoria.aud_idAuditoriaOriginal ? false : this.props.puedeModificar
                        ref={ref => this.inputFecha = ref}
                        diaSemana={this.props.auditoria.aud_fechaProgramadaDOW}
                        fechaConProblemas={this.props.auditoria.local_topeFechaConInventario}
                        fecha={this.props.auditoria.aud_fechaProgramada}
                        onGuardar={this.guardarAuditoria.bind(this)}
                        focusRowAnterior={() => this.props.focusRow(this.props.index - 1, 'dia')}
                        focusRowSiguiente={() => this.props.focusRow(this.props.index + 1, 'dia')}
                    />
                </td>
                {/* Cliente*/}
                <td className={css.tdCliente}>
                    <p>{this.props.auditoria.cliente_nombreCorto}</p>
                </td>
                {/* CECO */}
                <td className={css.tdCeco}>
                    <p className={css.textoConTooltip}>
                        <b>{this.props.auditoria.local_ceco}</b>
                        {this.props.auditoria.ultimas_ai
                            ? <span>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start'
                                }}>
                                    <div>Ultima Auditoria:</div>
                                    <div>- Fecha: {this.props.auditoria.ultimas_ai.fecha}</div>
                                    <div>- Auditor: {this.props.auditoria.ultimas_ai.auditor}</div>
                                    <div>- Venc: {this.props.auditoria.ultimas_ai.muestra_venc}</div>
                                </div>
                            </span>
                            : <span>Sin registros</span>}
                    </p>
                </td>
                {/* Local */}
                <td className={css.tdTienda}>
                    <p><small><b>{this.props.auditoria.local_nombre}</b></small></p>
                </td>
                {/* Region */}
                <td className={css.tdRegion}>
                    <p>{this.props.auditoria.local_region}</p>
                </td>
                {/* Comuna */}
                <td className={css.tdComuna}>
                    <p style={{ margin: 0 }}><b><small>{this.props.auditoria.local_comuna}</small></b></p>
                </td>
                {/* Dirección */}
                <td className={css.tdDireccion}>
                    {this.props.auditoria.local_gmap_latitud && this.props.auditoria.local_gmap_longitud
                        ? <a href={`https://www.google.com/maps/search/?api=1&query=${this.props.auditoria.local_gmap_latitud}, ${this.props.auditoria.local_gmap_longitud}`}
                            target="_blank">
                            {this.props.auditoria.local_direccion}<span className='glyphicon glyphicon-map-marker'></span>
                        </a>

                        : this.props.auditoria.local_direccion}


                </td>
                {/* Auditor */}
                <td className={css.tdAuditor}>
                    <Select
                        ref={ref => this.selectAuditor = ref}
                        seleccionada={this.props.auditoria.aud_idAuditor ? '' + this.props.auditoria.aud_idAuditor : ''}   // debe ser string
                        onSelect={this.guardarAuditoria.bind(this)}
                        opciones={opcionesAuditores}
                        opcionNula={true}
                        opcionNulaSeleccionable={true}
                        puedeModificar={this.props.puedeModificar} />
                </td>
                {/* Cantidad Muestra Obligatoria */}
                {this.props.puedeRevisarCantidadMuestras ?
                    <td className={css.tdCantidadMuestra}>
                        <p className={css.textoConTooltip}>
                            {this.props.auditoria.aud_mvencimientoDisponible}
                            <span>StocK: {this.props.auditoria.local_stockF}</span>
                        </p>
                    </td>
                    :
                    <td></td>
                }
                {/* Diferencia Muestra Auditada - Muestra Medidas */}
                {this.props.puedeRevisarCantidadMuestras ?
                    <td className={css.tdCantidadMuestra}>
                        <p className={css.textoConTooltip}>
                            {this.props.auditoria.aud_mvencimientoDiferencia}
                            <span>Stock: {this.props.auditoria.local_stockF}</span>
                        </p>
                    </td>
                    :
                    <td></td>
                }
                {/* Suspendido */}
                <td className={css.tdSuspendido}>
                    <Select
                        ref={ref => this.selectSuspendida = ref}
                        seleccionada={this.props.auditoria.aud_suspendida ? '' + this.props.auditoria.aud_suspendida : ''}
                        onSelect={this.guardarAuditoria.bind(this)}
                        opciones={[
                            { valor: '1', texto: 'No aplica' },
                            { valor: '2', texto: 'Remodelación' },
                            { valor: '3', texto: 'Falta Personal' },
                            { valor: '4', texto: 'Corte electricidad' },
                            { valor: '5', texto: 'QF suspende' },
                            { valor: '6', texto: 'Auditor no asiste' },
                            { valor: '9', texto: 'Pago 50%' },
                            { valor: '8', texto: 'Fase 2' },
                            { valor: '10', texto: 'Medición Especial' },
                            { valor: '11', texto: 'No Pago' },
                            { valor: '7', texto: 'Otro' }
                        ]}
                        puedeModificar={!this.props.auditoria.aud_perecible ? this.props.puedeModificar : false}
                    />
                </td>
                {/* Observacion */}
                <td className={css.tdObservaciones}>
                    <InputObservaciones
                        ref={ref => this.inputObservacion = ref}
                        asignada={this.props.auditoria.aud_observacion ? '' + this.props.auditoria.aud_observacion : ''}  // pide en string
                        tooltipText={'Observaciones'}
                        onGuardar={this.guardarAuditoria.bind(this)}
                        puedeModificar={!this.props.auditoria.aud_perecible ? this.props.puedeModificar : false}
                    />
                </td>
                <td className={css.tdDescargaIrd}>
                    {(!this.props.auditoria.aud_sensores && this.props.auditoria.cliente_idCliente != 19) && (
                        this.props.auditoria.aud_descarga_ird ?
                            <button className="btn btn-xs btn-success"><span className="glyphicon glyphicon-ok-circle"></span></button>
                            :
                            <button className="btn btn-xs btn-danger"><span className="glyphicon glyphicon-dashboard"></span></button>
                    )}
                </td>
                {/* Opciones */}
                <td className={css.tdLink}>
                    < ArchivoFinal auditoria={this.props.auditoria} fcv={this.props.fcv} />
                </td>
                <td className={css.tdLink}>
                    <Revision auditoria={this.props.auditoria} puedeModificar={this.props.puedeModificar}/>
                </td>
            </tr>
        )
    }
}

const Revision = ({ auditoria, puedeModificar }) => {
    if (auditoria.cliente_idCliente == 19) {

        if (auditoria.aud_revisada) {
            return <a className="btn btn-xs btn-info" href={`/auditoriaSCF/${auditoria.aud_idAuditoria}/revision`} target="_blank"><span className="glyphicon glyphicon-eye-open"></span></a>;
        }
        if (!puedeModificar) {
            return null;
        }
        return <a
            className={auditoria.aud_estadoArchivoFinal == 'por publicar' ? "btn btn-xs btn-danger" : "btn btn-xs btn-success"}
            href={`/auditoriaSCF/${auditoria.aud_idAuditoria}/revision`}
            target="_blank"
        >
            <span className="glyphicon glyphicon-eye-open">
            </span>
        </a>;
    }

    return (
        auditoria.aud_realizadaInformada
            ? <a className={"btn btn-xs btn-info"} href={`/auditoria/${auditoria.aud_idAuditoria}/revision`} target="_blank"><span className="glyphicon glyphicon-eye-open"></span></a>
            : <a className={auditoria.aud_estadoArchivoFinal == 'por publicar' ? "btn btn-xs btn-danger" : "btn btn-xs btn-success"} href={`/auditoria/${auditoria.aud_idAuditoria}/revision`} target="_blank"><span className="glyphicon glyphicon-eye-open"></span></a>

    );

}

const ArchivoFinal = ({ auditoria, fcv }) => {

    if (auditoria.cliente_idCliente == 19) {
        return (
            auditoria.aud_estadoArchivoFinal == 'por publicar'
                ? <a className="btn btn-xs btn-danger" href={`/auditoriaSCF/${auditoria.aud_idAuditoria}/archivo-final`} target={"_blank"}><span className="glyphicon glyphicon-time"></span></a>
                : <a className="btn btn-xs btn-success" href={`/auditoriaSCF/${auditoria.aud_idAuditoria}/archivo-final`} target="_blank"><span className="glyphicon glyphicon-compressed"></span></a>
        );
    }

    if (auditoria.aud_smuBodega || auditoria.aud_perecible) {
        return (
            auditoria.aud_estadoArchivoFinal == 'por publicar'
                ? <a className="btn btn-xs btn-danger" href="#"><span className="glyphicon glyphicon-time"></span></a>
                : <a className="btn btn-xs btn-success" href="#"><span className="glyphicon glyphicon-compressed"></span></a>
        );
    }

    return (
        auditoria.aud_estadoArchivoFinal == 'por publicar'
            ? <a className="btn btn-xs btn-danger" href={fcv ? null : (`/auditoria/${auditoria.aud_idAuditoria}/${auditoria.aud_sensores ? 'archivo-final-sensores' : 'archivo-final'}`)} target={fcv ? '' : "_blank"}><span className="glyphicon glyphicon-time"></span></a>
            : <a className="btn btn-xs btn-success" href={fcv && auditoria.aud_sensores ? null : `/auditoria/${auditoria.aud_idAuditoria}/${auditoria.aud_sensores ? 'archivo-final-sensores' : 'archivo-final'}`} target="_blank"><span className="glyphicon glyphicon-compressed"></span></a>
    );
}

RowAuditoriaSemanal.propTypes = {
    // Objetos
    puedeModificar: React.PropTypes.bool.isRequired,
    puedeRevisar: React.PropTypes.bool.isRequired,
    index: React.PropTypes.number.isRequired,
    auditoria: React.PropTypes.object.isRequired,
    auditores: React.PropTypes.array.isRequired,
    mostrarSeparador: React.PropTypes.bool.isRequired,
    // Metodos
    guardarAuditoria: React.PropTypes.func.isRequired,
    eliminarAuditoria: React.PropTypes.func.isRequired,
    focusRow: React.PropTypes.func.isRequired
}
RowAuditoriaSemanal.defaultProps = {
    mostrarSeparador: false
}

export default RowAuditoriaSemanal


// WEBPACK FOOTER //
// ./frontEnd/auditorias/programacion-semanal/RowAuditoriaSemanal.jsx